$(document).ready(function() {
    // When a tab is clicked
    $('.tabs_header_tab').on('click', function() {
        // Remove the active class from all tabs and content boxes
        $('.tabs_header_tab').removeClass('active');
        $('.content-box').removeClass('active');
        
        // Add the active class to the clicked tab
        $(this).addClass('active');
        
        // Get the content associated with the clicked tab
        var contentId = $(this).data('content');
        
        // Show the corresponding content box and add the active class
        $('#' + contentId).addClass('active');
    });
});

$(document).ready(function () {
    function showRelevantVariant() {
        // Get the current URL and extract the variant ID
        let currentUrl = window.location.href;
        console.log("Current URL on page load or change:", currentUrl);

        let url = new URL(currentUrl);
        let variantId = url.searchParams.get("variant");

        // Use selectedVariantId as a fallback if variantId is not present in URL
        if (!variantId) {
            variantId = $('.selected-variant-id').attr('id');
        }
        console.log("Variant ID to display:", variantId);

        // Show the relevant .variant-id div and hide others
        $(".variant-id").each(function () {
            if ($(this).attr("variant-id") === variantId) {
                $(this).css("display", "block");
            } else {
                $(this).css("display", "none");
            }
        });
    }

    // Run the function on page load to set the default display
    showRelevantVariant();

    // Event listener for size selector and color swatch changes
    $(".product-form__single-selector").on("change", function () {
        // Log the current URL before the change
        console.log("URL before change:", window.location.href);

        // Determine which element triggered the change
        if ($(this).is("select")) {
            console.log("Size selector clicked");
        } else if ($(this).is("input[type='radio']")) {
            console.log("Color swatch clicked");
        }

        // Use a slight delay to ensure the URL is updated after the change
        setTimeout(function () {
            // Run the function to update display based on the new URL
            showRelevantVariant();
        }, 100);
    });
});
$(document).ready(function () {
    function showRelevantDescription() {
        // Get the current URL and extract the variant ID
        let currentUrl = window.location.href;
        console.log("Current URL on page load or change:", currentUrl);

        let url = new URL(currentUrl);
        let variantId = url.searchParams.get("variant");

        // Use selectedVariantId as a fallback if variantId is not present in URL
        if (!variantId) {
            variantId = $('.selected-variant-id').attr('id');
        }
        console.log("Variant ID for description:", variantId);

        // Show the relevant description and hide others
        $(".product-block-list__item--description.variant").each(function () {
            if ($(this).attr("variant-id") === variantId) {
                $(this).css("display", "block");
            } else {
                $(this).css("display", "none");
            }
        });
    }

    // Run the function on page load to set the default display
    showRelevantDescription();

    // Event listener for size selector and color swatch changes
    $(".product-form__single-selector").on("change", function () {
        // Log the current URL before the change
        console.log("URL before change:", window.location.href);

        // Determine which element triggered the change
        if ($(this).is("select")) {
            console.log("Size selector clicked");
        } else if ($(this).is("input[type='radio']")) {
            console.log("Color swatch clicked");
        }

        // Use a slight delay to ensure the URL is updated after the change
        setTimeout(function () {
            // Run the function to update display based on the new URL
            showRelevantDescription();
        }, 100);
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const specBlocks = document.querySelectorAll(
    ".product-block-list__item.product-block-list__item--content.Specifications"
  );

  specBlocks.forEach(function (block) {
    const content = block.querySelector(".rte.text--pull");

    if (!content || content.textContent.trim() === "") {
      block.remove();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.main-product-overview').forEach(function (overview) {
        const productInner = overview.querySelector('.product_inner');

        if (productInner && productInner.innerHTML.trim() === '') {
            overview.style.display = 'none';
        }
    });
});







